import { updateAllSettingSucceed } from '../actions';
import { addSetting } from 'common/services/settings.service';

export const updateSetting =
  ({ name, value, params }) =>
  async dispatch => {
    const setting = await addSetting({ name, value, params });
    dispatch(updateAllSettingSucceed({ name, value }));
    return setting;
  };
